import { RouteConfig } from 'vue-router'
import i18 from '@/i18n'

const route: RouteConfig[] = [
    {
        path: '/account/install',
        name: 'account_install',
        meta: { title: i18.t('integration', { brand: process.env.VUE_APP_BRAND }) },
        component: () => import('@/modules/installer/components/Stepper.vue')
    }
]

export default route
